import SubpageHero from "@/components/site/SubpageHero";
import WannHilfe from "@/components/site/WannHilfe";
import ErsteHilfe from "@/components/site/ErsteHilfe";
import Marquee from "@/components/site/Marquee";
import Kontakt from "@/components/site/Kontakt";

export default function HilfePage() {
  return (
    <>
      <SubpageHero
        testId="page-hilfe"
        eyebrow="Ein kleiner Igel braucht dich"
        titleLines={["Braucht dieser Igel", "Hilfe?"]}
        accent="text-brand-pink"
        intro="Nicht jeder Igel, den man findet, ist in Not. Aber wenn einer Hilfe braucht, zählt jede Minute. Hier erkennst du die Warnsignale – und weißt sofort, was zu tun ist."
      />
      <WannHilfe />
      <Marquee />
      <ErsteHilfe />
      <Kontakt />
    </>
  );
}
